import axios from "axios";
import ApiConstants from "../Utils/ApiConstant";
import SessionManager from "../Utils/Session";

const SubjectService = {
  // Existing login function
  getAllSubjects: async (offset, limit, searchQuery, class_id) => {
    try {
      let url = ApiConstants.getAllSubjects + `?offset=${offset}&limit=${limit}&searchQuery=${searchQuery.trim()}`;
      if (class_id) {
        url += `&class_id=${class_id}`;
      }
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
        },
      });
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  getAllSubjectsWithoutPagination: async (classId) => {
    try {
      const response = await axios.get(ApiConstants.getAllSubjectsWithoutPagination + `?class_id=${classId}`, {
        headers: {
          Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
        },
      });
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
  getAllSubQuestions: async (question_id) => {
    try {
      const response = await axios.get(
        ApiConstants.getAllSubQuestions + `?question_id=${question_id}`,
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  deleteSubject: async (id) => {
    try {
      const response = await axios.post(ApiConstants.deleteSubject, {
        ids: id
      },
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        });
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  updateSubjectStatus: async (id, status) => {
    try {
      const response = await axios.put(ApiConstants.updateSubjectStatus, {
        id: id,
        is_active: status
      }, {
        headers: {
          Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
        },
      });
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  addSubject: async ({ subject_name, class_id, subject_image, color }) => {
    try {
      const formData = new FormData();
      formData.append("subject_name", subject_name.trim() || "");
      formData.append("class_id", class_id || "");
      formData.append("subject_image", subject_image || "");
      formData.append("color_code", color || "");
      const response = await axios.post(
        ApiConstants.addSubject, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
        },
      }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  updateSubject: async ({ id, class_id, subject_name, subject_image, color }) => {
    try {
      const formData = new FormData();
      formData.append("id", id);
      formData.append("class_id", class_id);
      formData.append("subject_name", subject_name.trim());
      formData.append("subject_image", subject_image);
      formData.append("color_code", color);
      const response = await axios.put(
        ApiConstants.updateSubject, formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
};

export default SubjectService;
